module.exports = __webpack_public_path__ + "static/media/office1.03599e57.png";